import './App.css';
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages';
import { initScrollFunctions } from "./common/scrollFunctions";

function App() {
  useEffect(() => {
    initScrollFunctions();
}, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />        
      </Routes>
    </Router>
  );
}

export default App;
